export const STATUS_COLORS: Record<string, 'success' | 'error'> = {
    delivered: 'success',
    bounced: 'error',
};
